import React from "react";
import Button from "../Button";
import Image from "next/image";

type SdkOption = "react" | "javascript";

interface SdkSelectorProps {
  selected: SdkOption;
  onSelect: (sdk: SdkOption) => void;
}

const SdkSelector: React.FC<SdkSelectorProps> = ({ selected, onSelect }) => {
  return (
    <div className="grid grid-cols-2 gap-4 my-8">
      <Button
        onClick={() => onSelect("react")}
        selected={selected === "react"}
        accent
        className="flex-1 justify-center py-4"
      >
        <Image
          src="/logos/react-logo.png"
          alt="React Logo"
          width={26}
          height={26}
          className="mr-2"
        />
        <span className="text-base">React</span>
      </Button>
      <Button
        onClick={() => onSelect("javascript")}
        selected={selected === "javascript"}
        accent
        className="flex-1 justify-center py-4"
      >
        <Image
          src="/logos/javascript-logo.png"
          alt="JavaScript Logo"
          width={26}
          height={26}
          className="mr-2"
        />
        <span className="text-base">JavaScript</span>
      </Button>
    </div>
  );
};

export default SdkSelector;
